import { observer } from 'mobx-react-lite'
import { type DocumentDetailsModalViewModel } from './DocumentDetailsModalViewModel'
import { match } from '@/utils/pattern-match-util'
import { DocumentDetailsModal } from '@/features/documents/DocumentDetailsModal'
import { useActivation } from '@/hooks/view-model-hooks'
import { DocumentDetailsTabContainer } from './DocumentDetailsTab/DocumentDetailsTabContainer'

export interface DocumentDetailsModalContainerProps {
  vm: DocumentDetailsModalViewModel
}

export const DocumentDetailsModalContainer = observer(
  function DocumentDetailsModalContainer({
    vm,
  }: DocumentDetailsModalContainerProps) {
    useActivation(vm)
    return (
      <DocumentDetailsModal
        showing={vm.modal.showing}
        onClose={vm.close}
        fileType={vm.document.fileType}
        headerTitle={vm.headerTitle}
        backingFileName={vm.backingFileName}
        documentTypeName={vm.documentType ? vm.documentType.name : undefined}
        canEdit={vm.canEdit}
        canRemove={vm.canRemove}
        canDownload={vm.canDownload}
        isDetailsTab={vm.isDetailsTab}
        onSelectDetailsTab={vm.selectDetailsTab}
        hasChanges={vm.hasChanges}
        isPending={vm.isPending}
        isSavePending={vm.save.pending}
        onDiscardChanges={vm.discardChanges}
        onDelete={vm.delete}
        onDownload={vm.downloadLatest}
        onSave={vm.save}
      >
        {match(vm.tabController.current.tab, {
          Details: () => <DocumentDetailsTabContainer vm={vm} />,
        })}
      </DocumentDetailsModal>
    )
  },
)
